import styled from 'styled-components';
import { breakpoints } from 'Theme';
import { asRem } from 'utils';
import { colors } from 'Theme';

export default styled.div`
  align-items: center;
  height: ${asRem(115)};

  .mime-elements-slider.count-1 {
    .slick-track {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    height: ${asRem(140)};
  }

  @media (min-width: ${breakpoints.lg}) {
    height: ${asRem(125)};
  }

  @media (min-width: ${breakpoints.lg}) {
    .slider-wrapper {
      width: 80%;
      margin: auto;
    }
  }
  .mixed-coops {
    color: ${colors.blueGrey.c500};
  }

  .logo {
    aspect-ratio: 100 / 50;
    width: ${asRem(100)};
    height: ${asRem(50)};
    margin: 0 ${asRem(4)};

    @media (min-width: ${breakpoints.md}) {
      width: ${asRem(140)};
      height: ${asRem(70)};
      margin: 0 ${asRem(10)};
    }
  }
`;
